import qs from 'querystring';

import UTMZ from '@sravni/server-utils/lib/utmz';

import { PIXELS_TYPES } from '../../constants/analytics';
import { getGaIdFromCookies, getYandexMetricsId } from '../../utils/analytics';

const TYPES = {
  microcredit: 'Микрокредиты',
};

const SOURCES = {
  merchant: 'merchant',
};

const KEYS = {
  SUB: 'adv_sub',
  SOURCE: 'source',
  PATH: 'aff_sub2',
  UTM_MARKS: 'aff_sub3',
  PRODUCT: 'aff_sub4',
  TYPE: 'aff_sub5',
  GAID: 'aff_sub',
  USER_ID: 'aff_unique1',
  AFF_CLICK: 'aff_click_id',
};

export interface IMakePixelProps {
  sub?: string;
  affSub4?: string;
  type?: string;
  source?: string;
  organizationName?: string;
  pathname: string;
  userId?: string;
  route: string;
  pixelType?: string;
  cookie?: Record<string, any>;
}

export const updateLinkQuery = (link, query) => {
  if (link && typeof link === 'string') {
    const [url, originalQueryString = ''] = link.split('?');

    const propertiesString = qs.stringify({
      ...qs.parse(originalQueryString),
      ...query,
    });

    return `${url}?${propertiesString}`;
  }

  return link;
};

interface GetUTMZParams {
  url?: string;
  utmzCookie?: string;
}

const getUTMZ = ({ utmzCookie, url }: GetUTMZParams) => {
  if (utmzCookie) {
    return utmzCookie;
  }

  if (!url) {
    return null;
  }

  const utmMarksObject = UTMZ.getFromUrl(decodeURIComponent(url));
  const utmMarksString = UTMZ.createCookieString(utmMarksObject);

  return encodeURIComponent(utmMarksString);
};

const getClId = (key: string, value: string | undefined | string[]) => {
  if (value) {
    return `${key}|${value}`;
  }

  return undefined;
};

const getAffClId = ({ affClIdCookie, url }: { affClIdCookie?: string; url: string }) => {
  const [_, originalQueryString] = url.split('?');
  const { yclid, fbclid, gclid } = qs.parse(originalQueryString);

  return getClId('yclid', yclid) || getClId('fbclid', fbclid) || getClId('gclid', gclid) || affClIdCookie;
};

const makePixelLink = (link: string, props: IMakePixelProps): string | null => {
  const { affSub4, sub, organizationName, cookie, pathname, userId, pixelType } = props || {};

  const gaCookie = cookie?._ga;
  const utmzCookie = cookie?.__utmz;
  const utmz = getUTMZ({ url: pathname, utmzCookie });
  const affClIdCookie = cookie?.clid;
  const affClId = pixelType === PIXELS_TYPES.CLICK && getAffClId({ affClIdCookie, url: pathname });

  const patch = {
    [KEYS.SUB]: sub,
    [KEYS.TYPE]: TYPES.microcredit,
    [KEYS.SOURCE]: SOURCES.merchant,
  };

  if (cookie && gaCookie) {
    const yandexMetricsId = getYandexMetricsId(cookie);
    const affSubGoogle = `ga_${getGaIdFromCookies(gaCookie) || ''}`;
    const affSubYandex = yandexMetricsId ? `ym_${yandexMetricsId}` : '';
    patch[KEYS.GAID] = `${affSubGoogle}${affSubYandex ? `|${affSubYandex}` : ''}`;
  }

  if (pathname) {
    const [path] = pathname.split('?');
    patch[KEYS.PATH] = path;
  }

  if (affSub4 || organizationName) {
    patch[KEYS.PRODUCT] = affSub4 || `${organizationName}`;
  }

  if (userId) {
    patch[KEYS.USER_ID] = String(userId);
  }

  if (utmz) {
    patch[KEYS.UTM_MARKS] = utmz;
  }

  if (affClId) {
    patch[KEYS.AFF_CLICK] = affClId;
  }

  return updateLinkQuery(link, patch);
};

export default makePixelLink;
